export const dirs = {
	STATIC_ROOT: window.STATIC_ROOT || '/',
	STATIC_ICONS_PATH: window.STATIC_ICONS_PATH || '/',
	WWW_ROOT: window.WWW_ROOT || '/'
};

export const settings = {
	namespace: 'framework',
	breakpoints: {
		minXS: '320',
		minSM: '500',
		minMD: '740',
		minLG: '980',
		minXL: '1220',
		minXXL: '1330'
	}
};
